import script from "./CreateAdditionTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateAdditionTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./CreateAdditionTemplate.vue?vue&type=style&index=0&id=7604ba4e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7604ba4e"]])

export default __exports__